import { createElement as h, forwardRef, useMemo } from 'react'
import { isString } from '../../core'

const baseStyleObj = { display: 'flex' }
const basePropsObj = {}
const ICON_TYPE = {
  /** 图标所在项目名 */
  FONT_FAMILY: 0,
  /** unicode类型值 */
  UNICODE:     1,
  /** fontClass类型值 */
  FONT_CLASS:  2,
  /** Symbol类型值 */
  SYMBOL:      3,
  /** B: 背景色 F: 字体色 */
  COLOR_TYPE:  4,
  /** 颜色 */
  COLOR:       5,
  /** 图标圆角度 */
  RADIUS:      6,
  /** 图标内边距 */
  PASSING:     7
}

const getIconHref = href => isString(href) ? `${href.startsWith('#') ? '' : '#'}${href}` : ''

const SvgIcon = forwardRef(({
  style = baseStyleObj,
  rotate = 0,
  href,
  size = 150,
  width,
  height,
  fill = '',
  ...args
}, ref) => {

  if (!width || !height) width = height = size

  /**
   * 数据格式：FontFamily|Unicode|FontClass|Symbol|ColorType|Color|Radius|Padding
   * 示例：font-live｜&#xe72d;｜icon-tongyong_shanchu2｜#icon-tongyong_shanchu2｜F｜#666｜5|10
   */
  const info = useMemo(() => {
    const info = {
      // 图标名称
      name:      null,
      // 图标颜色
      fill,
      // 父节点的属性
      baseProps: basePropsObj,
      // 需要父节点
      isBg:      false
    }
    const _s = href.split('|')
    if (_s.length > 1) {
      info.name = _s[ICON_TYPE.SYMBOL]
      const isBg = _s[ICON_TYPE.COLOR_TYPE] === 'B'
      info.fill = isBg ? '#fff' : _s[ICON_TYPE.COLOR]
      if (isBg) {
        info.isBg = isBg
        info.baseProps = {
          style: {
            background:   _s[ICON_TYPE.COLOR],
            padding:      (_s[ICON_TYPE.PASSING] || 0) + 'px',
            borderRadius: _s[ICON_TYPE.RADIUS] + 'px'
          }
        }
      }
    } else {
      info.name = getIconHref(href)
    }
    return info
  }, [ href ])

  const [ baseProps, childWidth, childHeight ] = useMemo(() => {
    const _baseProps = { ...info.baseProps, ref, ...args }
    let childWidth = 'auto'
    let childHeight = 'auto'
    if (size) {
      const _style = _baseProps.style = { ..._baseProps.style }
      _style.width = width
      _style.height = height
      // 获取要减去的padding
      const padding = (_style.padding ? _style.padding.slice(0, -2) : 0) * 2
      childWidth = width - padding
      childHeight = height - padding
    }
    return [ _baseProps, childWidth, childHeight ]
  }, [ info, width, height ])

  const childStyle = useMemo(() => {
    const _childStyle = {
      width:  childWidth,
      height: childHeight,
      fill:   fill || info.fill,
      ...style
    }
      ; (info.isBg ? baseProps.style : _childStyle).transition = '.3s all ease'
    ; (info.isBg ? baseProps.style : _childStyle).transform = `rotate(${rotate}deg)`
    return _childStyle
  }, [ baseProps, style, fill ])

  return (
    h(
      'div',
      baseProps,
      h(
        'svg',
        { style: childStyle },
        h(
          'use',
          { xlinkHref: info.name }
        )
      )
    )
  )

})

export {
  SvgIcon,
  getIconHref,
  basePropsObj
}